import {
    Directive,
    OnDestroy,
    OnInit,
    TemplateRef,
    ViewContainerRef,
} from '@angular/core';
import {
    AppStateFacade,
    Setting,
} from '@app-state';

import { Subject } from 'rxjs';
import {
    distinctUntilChanged,
    takeUntil,
} from 'rxjs/operators';

export abstract class UiContextDirectiveBase implements OnInit, OnDestroy {

    protected abstract _renderIf: (isModernFolderSystemEnabled: boolean) => boolean;
    private _destroyed$ = new Subject();

    constructor(
        private _ref: TemplateRef<{}>,
        private _container: ViewContainerRef,
        private _appState: AppStateFacade,
    ) { }

    ngOnInit() {
        this._appState
            .settings
            .get$(Setting.isModernFolderSystemEnabled)
            .pipe(
                distinctUntilChanged(),
                takeUntil(this._destroyed$),
            )
            .subscribe(value => {
                this._container.clear();

                if (this._renderIf(!!value)) {
                    this._container.createEmbeddedView(this._ref);
                }
            });
    }

    ngOnDestroy() {
        this._destroyed$.next();
    }
}

@Directive({
    selector: '[uiModernContext]',
})
export class UiModernContextDirective extends UiContextDirectiveBase {
    protected _renderIf = (value: boolean) => value;
}

@Directive({
    selector: '[uiLegacyContext]',
})
export class UiLegacyContextDirective extends UiContextDirectiveBase {
    protected _renderIf = (value: boolean) => !value;
}
